import React, { FC, MouseEventHandler } from 'react'

import Button from '@mui/material/Button'
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';

import { styled } from '@mui/material'
import { useLocalizedText } from '../context/Localization/localizationHooks';
import { LocalizedText } from '../context/Localization/LocalizationTypes';

const RootContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
}))

const ButtonRoot = styled(Button)(() => ({
    fontSize: '14px',
    textTransform: 'capitalize',
    borderRadius: '2px',
}))

const ButtonTextPrimary = styled(ButtonRoot)(({ error }: { error?: 0 | 1 | undefined }) => ({
    color: error ? 'red' : '#1872CC',
}))

interface SaveAsDraftProps {
    error: string
    handleSaveAsDraft: MouseEventHandler<HTMLButtonElement>
    hasDifference: boolean
    loading: boolean
    disabled: boolean
}
export const SaveAsDraft: FC<SaveAsDraftProps> = ({ loading, hasDifference, handleSaveAsDraft, error, disabled }) => {
    const SAVEASDRAFT = useLocalizedText(LocalizedText.SaveAsDraft)

    return (
        <RootContainer>
            <ButtonTextPrimary 
                variant="text" 
                color='primary' 
                onClick={handleSaveAsDraft}
                disabled={(loading || !hasDifference || disabled) && !error}
                error={error ? 1 : 0}
            >
                {SAVEASDRAFT}
            </ButtonTextPrimary>
            { loading && <CircularProgress size={17} /> }
            { error && (
                <Tooltip title={error} placement="top" arrow>
                    <ErrorIcon sx={{ color: 'red' }} />
                </Tooltip>
            ) }
        </RootContainer>
    )
}